import TableCell from "@mui/material/TableCell"
import TableRow from "@mui/material/TableRow"
import React from "react"
import { useSelector } from "react-redux/es/hooks/useSelector"
import { useSearchParams } from "react-router-dom"
import { useGetAllInterviewsQuery } from "../../../api/InterviewsApi"
import { useDispatch } from "react-redux/es/hooks/useDispatch"
import { RootState } from "../../../../../app/store"
import Skeleton from "@mui/material/Skeleton"

const InterviewsHeader = () => {
  const header = [
    { name: "ID", width: "68px" },
    { name: "Дата и время собеседования", width: "129px" },
    { name: "ФИО кандидата", width: "242px" },
    { name: "Собеседующий", width: "160px" },
    { name: "Тип собеседования", width: "133px" },
    { name: "Тип графика", width: "125px" },
    { name: "График", width: "117px" },
    { name: "Планируемая дата выхода", width: "116px" },
    { name: "Проект", width: "77px" },
    { name: "Дата и время создания собеседования", width: "200px" },
    { name: "Направление", width: "209px" },
    { name: "Линия", width: "135px" },
    { name: "Рекрутёр масснайма", width: "159px" },
    { name: "Статус", width: "172px" },
    { name: "", width: "54px" },
  ]

  const [searchParams, setSearchParams] = useSearchParams()
  const period = searchParams.get("period") || "all"
  const dispatch = useDispatch()

  const pagination = useSelector((state: RootState) => state.pagination)
  const interviews = useGetAllInterviewsQuery(
    `${pagination?.InterviewsPage}&period=${period}`,
  )

  if (interviews.isLoading) {
    return (
      <TableRow sx={{ width: "auto", borderRadius: "4px" }}>
        <Skeleton
          sx={{ bgcolor: "#EBEBEB", borderRadius: "4px" }}
          height={"57px"}
          animation="wave"
          variant="rectangular"
        />
      </TableRow>
    )
  }

  return (
    <TableRow
      sx={{
        bgcolor: (theme) =>
          theme.palette.mode === "dark"
            ? "rgb(55, 55, 55)"
            : "rgba(225, 225, 225, 1)",
      }}
    >
      {header.map((item) => (
        <TableCell
          key={item.name}
          sx={{
            fontSize: "14px",
            // minWidth: item.name.length > 30 ? "200px" : "auto",
            minWidth: item.width,
            lineHeight: "1.2",
            fontWeight: "bold",
            ":first-of-type": {
              borderRadius: "4px 0 0 4px",
            },
            ":last-of-type": {
              borderRadius: "0px 4px 4px 0px",
            },
            height: "57px",
          }}
        >
          {item.name}
        </TableCell>
      ))}
    </TableRow>
  )
}

export default InterviewsHeader
